import validate from "/usr/src/app/content/n3-spas-48bc1833-e1da-48b3-885b-624a2f33ad58/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-48bc1833-e1da-48b3-885b-624a2f33ad58/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}